import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Container, Spinner, Button, Badge } from 'react-bootstrap';
import { FaClock, FaBoxOpen, FaMoneyBill, FaCogs, FaClipboardList } from 'react-icons/fa';

export default function ReceivedBids() {
  const [matchedBids, setMatchedBids] = useState([]);
  const [loading, setLoading] = useState(true);
  const [now, setNow] = useState(Date.now());
  const [acceptedBids, setAcceptedBids] = useState({});

  const user = JSON.parse(sessionStorage.getItem('user'));
  const sellerId = user?.id;

  useEffect(() => {
    if (!sellerId) return;

    fetch(`https://vyaparapi.emedha.in/api/seller/matched-bids/${sellerId}`)
      .then(res => res.json())
      .then(async data => {
        const matched = data.matchedBids || [];

        const statusPromises = matched.map(bid =>
          fetch(`https://vyaparapi.emedha.in/api/seller/has-accepted?bid_id=${bid.bid_id}&seller_id=${sellerId}`)
            .then(res => res.json())
            .then(data => ({ bid_id: bid.bid_id, hasAccepted: data.hasAccepted }))
        );

        const statuses = await Promise.all(statusPromises);
        const acceptedMap = {};
        statuses.forEach(item => {
          acceptedMap[item.bid_id] = item.hasAccepted;
        });

        setAcceptedBids(acceptedMap);
        setMatchedBids(matched);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching matched bids:', err);
        setLoading(false);
      });
  }, [sellerId]);

  useEffect(() => {
    const interval = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(interval);
  }, []);

  const getTimeRemaining = (createdAt) => {
    const created = new Date(createdAt).getTime();
    const expires = created + 60 * 60 * 1000; // 60 minutes
    const diff = expires - now;
    return diff > 0 ? diff : 0;
  };

  const formatTimeLeft = (ms) => {
    const minutes = Math.floor(ms / 60000);
    const seconds = Math.floor((ms % 60000) / 1000);
    return `${minutes}m ${seconds < 10 ? '0' : ''}${seconds}s`;
  };

  const handleAccept = (bid) => {
    const sellerOffer = prompt(`Enter your offer amount for Bid ID: ${bid.bid_id}`);
    if (!sellerOffer || isNaN(sellerOffer)) {
      alert('❌ Please enter a valid amount.');
      return;
    }

    fetch('https://vyaparapi.emedha.in/api/seller/accept-bid', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        bid_id: bid.bid_id,
        seller_id: sellerId,
        seller_offer: parseFloat(sellerOffer)
      })
    })
      .then(res => res.json())
      .then(() => {
        alert(`✅ Bid accepted successfully!\nYou quoted ₹${sellerOffer}`);
      })
      .catch(err => {
        console.error('Error accepting bid:', err);
        alert('❌ Failed to accept the bid.');
      });
  };

  return (
    <Container className="my-5">
      <Card className="p-4 shadow-lg border-0" style={{ backgroundColor: '#fff' }}>
        <h3 style={{ color: '#062d59', borderBottom: '2px solid #e3080c', paddingBottom: '0.5rem', fontWeight: 'bold' }}>
          📥 Live Bids For You
        </h3>

        {loading ? (
          <div className="text-center my-5">
            <Spinner animation="border" variant="danger" />
          </div>
        ) : matchedBids.length === 0 ? (
          <p style={{ color: '#777', marginTop: '2rem' }}>No matched bids found for your products.</p>
        ) : (
          <Row className="mt-4">
            {matchedBids.filter((bid=>bid.status==='active')).map(bid => {
              const timeLeft = getTimeRemaining(bid.created_at);
              const isExpired = timeLeft <= 0;
              const alreadyAccepted = acceptedBids[bid.bid_id] || false;
              const disableAccept = isExpired || alreadyAccepted;

              return (
                <Col md={6} lg={4} key={bid.bid_id} className="mb-4">
                  <Card className="h-100 shadow-sm border-0" style={{ borderLeft: '5px solid #e3080c', borderRadius: '10px' }}>
                    <Card.Body style={{ backgroundColor: '#f8f9fa', borderRadius: '10px' }}>
                      <p className="mb-2"><FaClipboardList color="#062d59" /> <strong>Bid ID:</strong> {bid.bid_id}</p>
                      <p className="mb-2"><FaBoxOpen color="#062d59" /> <strong>Category:</strong> {bid.category} / {bid.sub_category}</p>
                      <p className="mb-2"><FaMoneyBill color="#062d59" /> <strong>Price Range:</strong> ₹{bid.price_from} - ₹{bid.price_to}</p>
                      <p className="mb-2"><FaCogs color="#062d59" /> <strong>Warranty:</strong> {bid.warranty}</p>
                      <p className="mb-2"><strong>🧩 Specs:</strong> <span style={{ color: '#e3080c' }}>{bid.selected_specs}</span></p>
                      <p className="mb-2"><FaClock color="#062d59" /> <strong>Created:</strong> {new Date(bid.created_at).toLocaleString()}</p>

                      <p className="mb-3">
                        {isExpired ? (
                          <Badge bg="secondary">⏱ Expired</Badge>
                        ) : alreadyAccepted ? (
                          <Badge bg="warning">✅ Already Accepted</Badge>
                        ) : (
                          <Badge bg="success">⏳ {formatTimeLeft(timeLeft)} left</Badge>
                        )}
                      </p>

                      <Button
                        variant={disableAccept ? 'secondary' : 'danger'}
                        disabled={disableAccept}
                        onClick={() => handleAccept(bid)}
                        style={{
                          width: '100%',
                          backgroundColor: disableAccept ? '#ccc' : '#e3080c',
                          borderColor: disableAccept ? '#ccc' : '#e3080c',
                          fontWeight: 'bold'
                        }}
                      >
                        Accept Bid
                      </Button>
                    </Card.Body>
                  </Card>
                </Col>
              );
            })}
          </Row>
        )}
      </Card>
    </Container>
  );
}
